/* Core & libraries */
import React, {useEffect, useState} from "react";
import {useTheme} from "react-jss";
import {FormattedMessage} from "react-intl";

/* Helpers, constants, custom methods, internal libraries */


/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import {ReactComponent as StarSvg} from '../../../resources/images/star.svg';
import {ReactComponent as DeleteIconRed} from "resources/images/delete-icon-red.svg";
import UCButton from "components/buttons";

/* Styles */
import styles from "./styles";

const LoyaltyDeleteFailedModal = ({row, updateRedemptionList, getLoyaltyList, removeFailedRedemptions}) => {
  const theme = useTheme();
  const classes = styles({theme});

  const [showLoyaltyDeleteFailedModal, setShowLoyaltyDeleteFailedModal] = useState(false)

  return (
    <>
      <UCButton
        className={classes.loyaltyDeleteFailedButton}
        type="none"
        text=""
        icon={<DeleteIconRed/>}
        onClick={() => setShowLoyaltyDeleteFailedModal(true)}
      />

      <UCModal
        className={classes.loyaltyDeleteFailedModal}
        showModal={showLoyaltyDeleteFailedModal}
        setShowModal={setShowLoyaltyDeleteFailedModal}
        modalIcon={<StarSvg/>}
        modalTitle={<FormattedMessage id="loyaltyDeleteFailedModal.title"/>}
        modalDescription={<FormattedMessage id="loyaltyDeleteFailedModal.description"/>}
        modalContent={<Content setShowModal={setShowLoyaltyDeleteFailedModal} row={row} updateRedemptionList={updateRedemptionList} getLoyaltyList={getLoyaltyList} removeFailedRedemptions={removeFailedRedemptions} />}
        dataTestId="loyaltyDeleteFailedModal"
      />
    </>

  )
}

export default LoyaltyDeleteFailedModal;
